/*
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2024-05-08 15:23:03
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-05-16 09:06:29
 */
import config from "./config/application";
import axios from "@/utils/request";
export const userQueryIdCard = (params) => axios.post(config.userQueryIdCard, params);
export const registrationDetail = (params) => axios.post(config.registrationDetail, params);
export const registrationCreate = (params) => axios.post(config.registrationCreate, params);
export const registrationEdit = (params) => axios.post(config.registrationEdit, params);
export const filterJobLevel = (params) => axios.post(config.filterJobLevel, params);
export const certificateMajor = params => axios.post(config.certificateMajor, params) // 证书查询专业
export const workJudge = params => axios.post(config.workJudge, params) // 工作证明判断
